export default __webpack_public_path__ + "static/media/ios-tv.77638530.png";